import React from 'react';
import { render, screen, fireEvent, act } from '@testing-library/react';
import '@testing-library/jest-dom';
import StyledSnackbar from '../StyledSnackbar';
import { theme } from '../../../../../components/ThemeContext/ThemeObject';

function hexToRgb(hex: string): string {
  const sanitized = hex.replace('#', '');
  const bigint = parseInt(sanitized, 16);
  const r = (bigint >> 16) & 255;
  const g = (bigint >> 8) & 255;
  const b = bigint & 255;
  return `rgb(${r}, ${g}, ${b})`;
}
// Mock Portal component
jest.mock('@mui/base', () => ({
  Portal: ({ children }: { children: React.ReactNode }) => <div>{children}</div>
}));

describe('StyledSnackbar', () => {
  const mockSetSnackbarState = jest.fn();

  beforeEach(() => {
    jest.clearAllMocks();
    jest.useFakeTimers();
  });

  afterEach(() => {
    jest.useRealTimers();
  });

  it('should render with success state and correct colors', () => {
    render(
      <StyledSnackbar
        message="Success message"
        state="success"
        setSnackbarState={mockSetSnackbarState}
      />
    );

    const snackbar = screen.getByTestId('SnackbarContent');
    expect(snackbar).toHaveStyle(`background-color: ${hexToRgb(theme.palette.success.light)}`);

    const icon = screen.getByTestId('CheckCircleIcon');
    expect(icon).toHaveStyle(`color: ${hexToRgb(theme.palette.success.secondary)}`);
  });

  it('should render with warning state and correct colors', () => {
    render(
      <StyledSnackbar
        message="Warning message"
        state="warning"
        setSnackbarState={mockSetSnackbarState}
      />
    );

    const snackbar = screen.getByTestId('SnackbarContent');
    expect(snackbar).toHaveStyle(`background-color: ${hexToRgb(theme.palette.opaque.yellow)}`);

    const icon = screen.getByTestId('WarningIcon');
    expect(icon).toHaveStyle(`color: ${hexToRgb(theme.palette.secondary.yellow)}`);
  });

  it('should render with error state and correct colors', () => {
    render(
      <StyledSnackbar
        message="Error message"
        state="error"
        setSnackbarState={mockSetSnackbarState}
      />
    );

    const snackbar = screen.getByTestId('SnackbarContent');
    expect(snackbar).toHaveStyle(`background-color: ${hexToRgb(theme.palette.error.light)}`);

    const icon = screen.getByTestId('CancelIcon');
    expect(icon).toHaveStyle(`color: ${hexToRgb(theme.palette.error.main)}`);
  });

  it('should auto-dismiss after 2 second', () => {
    render(
      <StyledSnackbar
        message="Test message"
        state="success"
        setSnackbarState={mockSetSnackbarState}
      />
    );

    expect(screen.getByText('Test message')).toBeInTheDocument();

    act(() => {
      jest.advanceTimersByTime(2000);
    });

    expect(mockSetSnackbarState).toHaveBeenCalledWith({
      message: '',
      state: 'success'
    });
  });

  it('should dismiss when clicking the dismiss button', () => {
    render(
      <StyledSnackbar
        message="Test message"
        state="success"
        setSnackbarState={mockSetSnackbarState}
      />
    );

    const dismissButton = screen.getByText('DISMISS');
    fireEvent.click(dismissButton);

    expect(mockSetSnackbarState).toHaveBeenCalledWith({
      message: '',
      state: 'success'
    });
  });
});
